// extracted by mini-css-extract-plugin
export default {"wrapper":"Portal_wrapper__5W6zP"};